import { AuthCard } from "../auth/AuthCard";

/**
 * 앱 초기화 splash. 로그인/콜백과 같은 `AuthCard` 로 그려, 부트부터 로그인까지
 * 카드 프레임이 유지된 채 내용만 바뀌게 한다(카드가 깜빡이며 나타났다 사라지지 않음).
 */
export function AppSplash() {
  return <AuthCard status={{ kind: "pending", message: "Spawning Pool을 시작하고 있습니다." }} />;
}
